<script setup>
import '@/styles/css/pricing-upstox.scss'
import '@/styles/css/seo-calculators.scss'
import '@/styles/css/rating-amc-brokerage-backed-by-best.scss'
import '@/styles/css/upstox-pricing.scss'
import { onMounted } from 'vue';
onMounted(()=>{
  require('@/assets/js/pricing.js')
})
</script>
<template>
  <main class="upstox-pricing-design upstox-design-base upstox-pricing">
    <!-- Pricing Top Head -->
    <!-- Pricing Section -->
    <section class="pricing-top-head">
      <div class="container">
        <div class="sec-heading">
          <h1 class="fs-96 sub-title blue bold sec-headingg">
            Brokerage Charges
          </h1>
          <p class="fs-24 mg-t-16 fw-600 main-sub-titlee">
            List of everything you may be charged at Upstox.
          </p>
          <div class="main-price-box">
            <div class="price-row pricing-main-content-row">
              <div class="price-item">
                <div class="price bold fs-96 fw-500">
                  <span class="fs-24">₹</span>0
                </div>
                <div class="price-text-content">
                  <div class="price-title fs-16 bold mg-t-8">AMC*</div>
                  <div class="price-desc fs-16 fw-400 mg-t-8">
                    Account Maintenance Charges <br />(No account maintenance
                    charges for first year)
                  </div>
                </div>
              </div>
              <div class="price-item">
                <div class="price bold fs-96 fw-500">
                  <span class="fs-24">₹</span>0
                </div>
                <div class="price-text-content">
                  <div class="price-title fs-16 bold mg-t-8">Brokerage*</div>
                  <div class="price-desc fs-16 fw-400 mg-t-8">
                    On Mutual Funds and IPOs
                  </div>
                </div>
              </div>
              <div class="price-item">
                <div class="price bold fs-96 fw-500">
                  <span class="fs-24">₹</span>20
                </div>
                <div class="price-text-content">
                  <div class="price-title fs-16 bold mg-t-8">Brokerage*</div>
                  <div class="price-desc fs-16 fw-400 mg-t-8">
                    Maximum brokerage per order
                  </div>
                </div>
              </div>
            </div>
            <div class="line">
              <hr />
            </div>
            <div class="main-get-started-btn">
              <form onsubmit="return proceedWithLazyLogin(event, this)">
                <div class="form-row">
                  <div class="form-group">
                    <input
                      type="tel"
                      onkeypress="return isNumber(event)"
                      name="phone"
                      id="txtcontact"
                      class="form-control"
                      maxlength="10"
                      placeholder="Enter your mobile number"
                    />
                  </div>
                  <button type="submit" class="btn prple_btn desktop-btn">
                    Sign up
                  </button>
                </div>
                <div class="error-message" id="error-message"></div>
                <p>
                  *By signing up you agree to our
                  <a href="/open-demat-account-tnc/" class="bold"
                    >Terms and Conditions</a
                  >
                </p>
              </form>
            </div>
            <div class="rating-amc-brokerage-sec">
              <div class="row">
                <div class="col-md-7 pddg_col">
                  <div class="banner_txt">
                    <ul class="list-unstyled">
                      <li class="col-md-3 col-sm-3 col-xs-6">
                        <div>
                          <h5>
                            4.5+<span
                              ><img
                                src="https://upstox.com/app/uploads/2023/06/star_icon-1.png"
                                alt=""
                            /></span>
                          </h5>
                          <span>Avg. App rating</span>
                        </div>
                      </li>
                      <li class="col-md-3 col-sm-3 col-xs-6">
                        <div>
                          <img
                            src="https://upstox.com/app/uploads/2023/06/global_tiger-1.png"
                            alt=""
                          />
                          <span>Backed by the best</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Pricing Section -->
    <!-- End Pricing Top Head -->
    <!-- brokerage-calculator-sec start here-->
    <!-- End Perks Investing Section -->
    <!-- do more with less Section start here-->
    <section class="do-more-section flat-brokerage mobile-remove-pb">
      <div class="container">
        <div class="sec-heading">
          <h2 class="fs-32 blackColor title bold">Do more with less</h2>
        </div>
        <div class="flat-brokerage-inner">
          <div class="do-more row">
            <div class="col-md-6 mobile-width-column">
              <table class="flat-brokerage-table mobile-width">
                <thead>
                  <tr>
                    <th colspan="1">Order type</th>
                    <th colspan="1">Applicable margin on Equity</th>
                    <th colspan="1">
                      Applicable margin on
                      <ul>
                        <li>Index Futures and Stock Futures</li>
                        <li>Index and Stock Option Sell</li>
                        <li>NSE Currency Futures</li>
                        <li>MCX Futures</li>
                      </ul>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="bold-data">
                        <ul>
                          <li>Intraday order</li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data">up to 5x</div>
                    </td>
                    <td>
                      <div class="bold-data">1x</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="bold-data">
                        <ul>
                          <li>CO/OCO order</li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data">up to 5x</div>
                    </td>
                    <td>
                      <div class="bold-data">1x</div>
                    </td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <td>
                      <div class="bold-data">
                        <ul>
                          <li>Margin Trading Facility (MTF)</li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data">up to 4x</div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>Not Applicable</li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="long-row-data no-data">
                      <span>Note: No Margin for Options buying</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6">
              <table class="flat-brokerage-table last-row-border mobile-break">
                <thead>
                  <tr>
                    <th colspan="2">
                      <p>Is MTF chargeable?</p>
                      <p>
                        Yes, the following charges are applicable on MTF orders
                        over and above regular brokerage
                      </p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="bold-data">
                        <ul>
                          <li>Interest</li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            ₹20/day for every slab of ₹40,000 taken as MTF
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="bold-data">
                        <ul>
                          <li>Pledging charges</li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li class="mobile-text-color">
                            The cost of pledging, as well as unpledging, is ₹20
                            + GST per scrip.
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- do more with less Section end here -->
    <!-- Margin shortfall penalty Section start here-->
    <section class="do-more-section flat-brokerage mobile-sec-pd">
      <div class="container">
        <div class="sec-heading">
          <h2 class="fs-32 blackColor title bold">Margin shortfall penalty</h2>
        </div>
        <div class="flat-brokerage-inner">
          <div class="do-more row">
            <div class="col-md-6 mobile-btm-space">
              <table class="flat-brokerage-table last-row-border">
                <thead>
                  <tr>
                    <th>Shortfall collection for each client</th>
                    <th>Penalty percentage of the shortfall</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            (&lt; ₹1 lakh) and (&lt; 10% of applicable margin)
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li class="mobile-text-color">0.50%</li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            (&gt;= ₹1 lakh) or (&gt;= 10% of applicable margin)
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li class="mobile-text-color">1.00%</li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6">
              <div class="main-penalty-note">
                <div class="penalty-note data-text">
                  <p class="penalty-note-title">Note:</p>
                  <ul>
                    <li>
                      <p>
                        If there are more than 5 instances of a shortfall in a
                        calendar month, a penalty of 5% for every further
                        instance of the shortfall is applicable
                      </p>
                    </li>
                    <li>
                      <p>
                        If the margin shortfall continues for more than 3
                        consecutive days, a penalty of 5% is applied for each
                        subsequent instance of the margin shortfall
                      </p>
                    </li>
                    <li>
                      <p>
                        For MCX, if the margin shortfall is reported 3 times or
                        more during a month, i.e., either in consecutive
                        instances or in 3 different instances, the penalty would
                        be 5% from the 4th instance of the shortfall
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Margin shortfall penalty Section end here -->
    <!-- Charges Explained Section start here-->
    <section class="do-more-section charges-explained-sec flat-brokerage">
      <div class="container">
        <div class="sec-heading">
          <h2 class="fs-32 blackColor title bold">All Charges Explained</h2>
        </div>
        <div class="flat-brokerage-inner">
          <div class="do-more row">
            <div class="col-md-6">
              <div class="main-penalty-note charges-explained-column">
                <div class="charges-explained-content data-text">
                  <h3 class="penalty-note-title">A. UPSTOX CHARGES</h3>
                  <h4 class="penalty-note-title penalty-sub-title">
                    1. Brokerage
                  </h4>
                  <ul>
                    <li>
                      <p>
                        Up to ₹20/order charged on Stocks, F&amp;O, Commodity
                        and Currency trades
                      </p>
                    </li>
                    <li>
                      <p>Zero Commission on Mutual Funds and IPOs</p>
                    </li>
                  </ul>
                  <h4 class="penalty-note-title penalty-sub-title">
                    2. AMC/QMC
                  </h4>
                  <ul>
                    <li>
                      <p>
                        ZERO AMC is applicable for newly onboarded customers in
                        the first year
                      </p>
                    </li>
                    <p>
                      <b>Non-BSDA users: </b>
                      QMC of ₹ 75 per quarter + GST
                    </p>
                    <b>BSDA Users:</b>
                    <a
                      class="bsduser"
                      href="/support/solutions/articles/249935-what-is-bsda-"
                      target="_blank"
                      >Link</a
                    >
                  </ul>
                </div>
              </div>
              <div class="main-penalty-note charges-explained-column">
                <div class="charges-explained-content data-text">
                  <h3 class="penalty-note-title">B. GOVERNMENT CHARGES</h3>
                  <h4 class="penalty-note-title penalty-sub-title">
                    1. STT/CTT - Securities/Commodities transaction tax
                  </h4>
                  <ul>
                    <li>
                      <p>
                        Levied by the Government on Securities and Commodities
                      </p>
                    </li>
                    <li>
                      <p>
                        Charged on both buy and sell Stocks - Equity Delivery
                        orders
                      </p>
                    </li>
                    <li>
                      <p>Charged only on sell Intraday and F&amp;O orders</p>
                    </li>
                    <li>
                      <p>May be more than the brokerage we charge</p>
                    </li>
                  </ul>
                  <h4 class="penalty-note-title penalty-sub-title">
                    2. GST - Goods and Services Tax
                  </h4>
                  <ul>
                    <li>
                      <p>Levied by the government on the services rendered.</p>
                    </li>
                    <li>
                      <p>18% of (brokerage + transaction charges + Demat)</p>
                    </li>
                  </ul>
                  <h4 class="penalty-note-title penalty-sub-title">
                    3. Stamp duty charges
                  </h4>
                  <ul>
                    <li>
                      <p>
                        Stamp duty charges are a part of the state revenue
                        system
                      </p>
                    </li>
                    <li>
                      <p>
                        Applicable on the trading of Securities and Commodities
                      </p>
                    </li>
                    <li>
                      <p>
                        Since 2020, uniform stamp duty charges are applicable
                        across all the states in India.
                      </p>
                    </li>
                    <li>
                      <p>
                        Read more
                        https://upstox.com/announcements/demat-account/revision-in-stamp-duty-rates-on-1st-july-2020/
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="main-penalty-note charges-explained-column">
                <div class="charges-explained-content data-text">
                  <h3 class="penalty-note-title">C. REGULATORY CHARGES</h3>
                  <h4 class="penalty-note-title penalty-sub-title">
                    1. Transaction Charges
                  </h4>
                  <ul>
                    <li>
                      <p>
                        Charged by exchanges (NSE, BSE, MCX) on the value of
                        your transactions.
                      </p>
                    </li>
                    <li>
                      <p>
                        BSE has revised transaction charges in XC, XD, XT, Z and
                        ZP groups to ₹10,000 per crore w.e.f 01.01.2016. (XC and
                        XD groups have been merged into a new group X w.e.f
                        01.12.2017)
                      </p>
                    </li>
                    <li>
                      <p>
                        BSE has revised transaction charges in SS and ST groups
                        to ₹1,00,000 per crore of gross turnover.
                      </p>
                    </li>
                  </ul>
                  <h4 class="penalty-note-title penalty-sub-title">
                    2. SEBI Charges
                  </h4>
                  <ul>
                    <li>
                      <p>
                        Charged at ₹10 per crore by Securities and Exchange
                        Board of India for regulating the markets.
                      </p>
                    </li>
                  </ul>
                  <h4 class="penalty-note-title penalty-sub-title">
                    3. DP (Depository participant) charges
                  </h4>

                  <b>Male</b>
                  <ul>
                    <li>CDSL: ₹3.5</li>
                    <li>Upstox: ₹16.5</li>
                    <li>Total: ₹20.0 + GST</li>
                  </ul>
                  <b>Female</b>
                  <ul>
                    <li>CDSL: ₹3.25</li>
                    <li>Upstox: ₹16.75</li>
                    <li>Total: ₹20.0 + GST</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Charges Explained Section end here -->

    <!--  services charges Section start here-->

    <section class="do-more-section flat-brokerage services-charges">
      <div class="container">
        <div class="sec-heading">
          <h2 class="fs-32 blackColor title bold">
            Charges for other services
          </h2>
        </div>
        <div class="flat-brokerage-inner">
          <div class="do-more row">
            <div class="col-md-12 mobile-width-column">
              <table class="flat-brokerage-table last-row-border">
                <tbody>
                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector.png"
                                alt="services" /></span
                            >Margin Against Demat Holdings (can be used for
                            Futures buy and sell and Options Sell orders only
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            ₹20 + GST per scrip for pledging and unpledging
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-1.png"
                                alt="services" /></span
                            >Auto Square-off
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>₹75 + GST</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-2.png"
                                alt="services" /></span
                            >Call &amp; Trade
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>₹75 + GST</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-6.png"
                                alt="services" /></span
                            >P&amp;L/ CMR Physical copy
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>₹10 per page</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-2-1.png"
                                alt="services" /></span
                            >Off-market (to transfer shares between brokers)
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            1. Buy orders will continue to be charged at ₹100 or
                            1.5% of the transaction amount (whichever is lower)
                          </li>
                          <li>
                            2. ‘Invest More’ orders will be charged at ₹100 or
                            1.5% of the transaction amount (whichever is lower).
                          </li>
                          <li>
                            3. SIP orders will be charged at ₹10 or 1.5% of the
                            transaction amount (whichever is lower)
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-4-1.png"
                                alt="services" /></span
                            >Instant Withdrawal charges
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>₹20 + GST</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-4-1.png"
                                alt="services" /></span
                            >Netbanking charges (Razorpay / Atom)
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>₹7 (GST included)</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-8.png"
                                alt="services" /></span
                            >Buyback/Takeover/Delisting Charges
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>₹20 + GST</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-1.png"
                                alt="services" /></span
                            >Offer For Sale
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>₹20 + GST</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-6.png"
                                alt="services" /></span
                            >Account Opening Fees
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>Free</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-8.png"
                                alt="services" /></span
                            >API Subscription Charges
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>Free</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-8.png"
                                alt="services" /></span
                            >Interest on Delayed Payment
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            0.05% per day on account debit (negative balance)
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-8.png"
                                alt="services" /></span
                            >Dematerialisation charges
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>₹100 per certificate + ₹50 courier charges</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-6.png"
                                alt="services" /></span
                            >Account Modification charges
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>₹ 50 + GST</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            <span class="charges-icon">
                              <img
                                src="https://upstox.com/app/uploads/2023/01/Vector-4-1.png"
                                alt="services" /></span
                            >NDU Charges
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <div class="bold-data data-text">
                        <ul>
                          <li>
                            ₹200/- per request or 0.01% on transaction value
                            whichever is higher payable by the borrower for NDU
                            requests accepted by the lender
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- charges services Section start here-->

    <!-- Pricing Faqs -->
    <section class="pricing_help_section up-pricing-faqs pt-90 pb-180">
      <div class="container">
        <div class="sec-heading">
          <h2 class="fs-32 blackColor title bold">
            Common questions regarding your funds
          </h2>
        </div>
        <div
          class="panel-group panel-group-faqs"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingOne">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#accordion" 
                href="#collapseOne">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >After I sell a stock, why don’t I get to use 100% of
                    it?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapseOne" class="panel-collapse collapse">
              <div class="panel-body visible">
                From October 04, 2024, SEBI peak margin rules have changed the
                way sell amounts get credited to you. As per this, 100% of the
                sell amount is available for trading on the same day. And 100%
                of the sell amount will be available for withdrawal from T+1 day
                onwards. To know more on the impact of SEBI’s peak margin rules,
                <a
                  href="/support/solutions/articles/249123-what-is-the-settlement-cycle-when-you-sell-your-positions-and-holdings- "
                  target="_blank"
                  >click here.</a
                >
              </div>
            </div>
          </div>
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#accordion" 
                href="#collapseTwo">
                  <span class="expand_icon dashicons-plus"></span>
                  <span
                    >Why is my fund balance lesser than what I expected?</span
                  >
                </span>
              </h3>
            </div>
            <div id="collapseTwo" class="panel-collapse collapse">
              <div class="panel-body visible">
                Your fund balance could be lesser than what you expect it to be
                because of multiple reasons such as maintenance charges, taxes,
                quarterly settlement/retention and more. To know about these in
                detail,
                <a
                  href="/support/solutions/articles/248628-why-is-my-fund-balance-lesser-than-what-i-expected- "
                  target="_blank"
                  >click here.</a
                >
              </div>
            </div>
          </div>
          <div class="panel panel-default">
            <div class="panel-heading" id="headingThree">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#accordion" 
                href="#collapseThree">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Why am I charged for equity delivery?</span>
                </span>
              </h3>
            </div>
            <div id="collapseThree" class="panel-collapse collapse">
              <div class="panel-body visible">
                We follow a pay-per-use model. We only charge a minimal
                brokerage up to ₹20 when you place a trade. To know more,
                <a
                  href="/support/solutions/articles/257195-how-are-the-charges-calculated- "
                  target="_blank"
                  >click here.</a
                >
              </div>
            </div>
          </div>
          <div class="panel panel-default">
            <div class="panel-heading" id="headingFive">
              <h3 class="panel-title">
                <span class="panel-trigger" data-toggle="collapse" data-parent="#accordion" 
                href="#collapseFive">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Where can I see all charges that are deducted?</span>
                </span>
              </h3>
            </div>
            <div id="collapseFive" class="panel-collapse collapse">
              <div class="panel-body visible">
                Whenever you trade, you need to check the order details or
                contract note to know how much amount will be credited or
                debited from your account. Contract note or order details can be
                checked under Ledger report or directly in the Bill report. To
                know how to access your ledger,
                <a
                  href="/support/solutions/articles/248670-what-is-ledger-report-and-how-do-i-access-it- "
                  target="_blank"
                  >click here</a
                >
                and to know how to read a ledger,
                <a
                  href="/support/solutions/articles/230036-how-do-i-read-my-ledger- "
                  target="_blank"
                  >click here.</a
                >
              </div>
            </div>
          </div>
          <div id="more-faqs" class="d-none">
            <div class="panel panel-default">
              <div class="panel-heading" id="headingSix">
                <h3 class="panel-title">
                  <span class="panel-trigger" data-toggle="collapse" data-parent="#accordion" 
                  href="#collapseSix">
                    <span class="expand_icon dashicons-plus"></span>
                    <span>What is a margin?</span>
                  </span>
                </h3>
              </div>
              <div id="collapseSix" class="panel-collapse collapse">
                <div class="panel-body visible">
                  Margin is the amount the broker provides over and above your
                  available purchasing power. Many times, the terms "margin" and
                  "exposure" are used interchangeably. If a broker is providing
                  "2x exposure", that is the same as saying that the broker is
                  providing "50% margin". To know more on Margin,
                  <a
                    href="/support/solutions/articles/40827-what-is-margin- "
                    target="_blank"
                    >click here.</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<style scoped lang="scss">
.row{
  justify-content: center;
  height: auto;
  @apply md:flex;
}
.tab.active::before{
  background: transparent;
}
.rating-amc-brokerage-sec ul.list-unstyled {
    margin: 48px auto auto;
    justify-content: center;
    li{
      span {
        display: inline;
        img{
          display: inline;
        }
      }
    }
}
</style>
